import * as React from "react";
import Modal from "@mui/material/Modal";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Form, Formik } from "formik";
import theme from "../../../theme";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { StyledBox, StyledBoxFlex } from "../success-virtual-locker/style";
import CrossIcon from "../../../assets/Icons/CrossIcon";
import CustomInput from "../../common/input/CustomInput";
import CustomDropdown from "../../common/common-dropdown/CustomDropdown";
import { DeclarationTypeOptionDropdown } from "../product-details/constant";
import {  SETTING_DECLARATIONS_ADD, SETTING_DECLARATIONS_EDIT, SETTING_DECLARATIONS_LIST } from "../../../actions/admin/customer-actions";
import { StyledBoxCard } from "../setting-coupon/style";
import { StyledTypography } from "../manual-split-calculation/style";

// Yup Validation Schema
const validationSchema = Yup.object({

  name: Yup.string()
    .trim()
    .required("name is required")
    .min(2, "name must be at least 2 characters")
    .max(50, "name must be at most 50 characters"),

  type: Yup.string()
    .required("Type to is required"),

  countries: Yup.string()
    .required("Countries from is required"),
  
  status: Yup.string()
    .required("Status is required"),

});

export default function SettingDeclarations({ open, handleClose, isEditMode, editRecord }) {
  const dispatch = useDispatch();
  const [initialValue, setInitialValue] = React.useState({
    name: "",
    type: "",
    status: "",
    countries: "",
  })
  
  const getRecordList = React.useCallback(
    (values) => {
      dispatch({
        type: SETTING_DECLARATIONS_LIST,
        payload: values,
      });
    },
    [dispatch]
  );

  React.useEffect(()=>{
    if(isEditMode){
      setInitialValue({
        name: editRecord?.name || "",
        type: editRecord?.type || "",
        status: editRecord?.status || "",
        countries: editRecord?.countries || "",
      })
    }
  }, [isEditMode, editRecord])
 
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <StyledBoxCard>
          <StyledBoxFlex>
            <StyledTypography>Create Declarations</StyledTypography>
          </StyledBoxFlex>
          <CrossIcon color={theme.palette.custom.white} onClick={handleClose} />
        </StyledBoxCard>

        <Formik
          initialValues={initialValue}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={(values) => {
            if(isEditMode && editRecord.id){
              dispatch({
                type: SETTING_DECLARATIONS_EDIT,
                payload: {
                  ...values,
                  id: editRecord.id,
                  onSuccess: () => {
                    getRecordList({});
                    handleClose();
                  },
                },
              });
            } else {
              dispatch({
                type: SETTING_DECLARATIONS_ADD,
                payload: {
                  ...values,
                  onSuccess: () => {
                    getRecordList({});
                    handleClose();
                  },
                },
              });
            }
          }}
        >
          {({ values, errors, touched, setFieldValue, handleChange, handleBlur }) => (
            <Form>
              <Box sx={{ p: 2 }}>
                <Grid container spacing={2}>
                  {/* name */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="10px"
                      required
                      placeholder="name"
                      customLabel="Name"
                      name={`name`}
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.name &&
                        Boolean(errors.name)
                      }
                      helperText={
                        touched.name &&
                        errors.name
                      }
                    />
                  </Grid>

                  {/* type */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                  <CustomDropdown
                      options={DeclarationTypeOptionDropdown}
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="44px"
                      required
                      customLabel="Type"
                      name={`type`}
                      value={values.type}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={
                        touched.type &&
                        Boolean(errors.type)
                      }
                      helperText={
                        touched.type &&
                        errors.type
                      }
                    />
                  </Grid>
                  {/* countries */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomInput
                        color={
                          theme.palette.custom.productTextColor
                        }
                        fontSize={theme.typography.regular.fontSize}
                        height="10px"
                        required
                        // type="date"
                        placeholder="countries"
                        customLabel="Countries"
                        name={`countries`}
                        onChange={handleChange}
                        value={values.countries}
                        onBlur={handleBlur}
                        error={
                          touched.countries &&
                          Boolean(errors.countries)
                        }
                        helperText={
                          touched.countries &&
                          errors.countries
                        }
                      />
                  </Grid>
                  {console.log('valeus===>', values)}
                  {/* Status */}
                  <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <CustomDropdown
                      options={[
                        { label: "Active", value: "active" },
                        { label: "Draft", value: "draft" },
                      ]}
                      color={
                        theme.palette.custom.productTextColor
                      }
                      fontSize={theme.typography.regular.fontSize}
                      height="44px"
                      required
                      customLabel="Status"
                      name={`status`}
                      value={values?.status}
                            // onChange={(val) => {
                      //   console.log('val===>', val?.target?.value);
                      //   // setFieldValue("status", val)}
                      // }}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={touched?.status && Boolean(errors.status)}
                      helperText={touched?.status && errors.status}
                    />
                  </Grid>
                 {/* Submit */}
                  <Grid container justifyContent="space-between" width="100%">
                    <Grid item>
                      <Button variant="outlined" onClick={handleClose}>
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button variant="contained" color="primary" type="submit">
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </StyledBox>
    </Modal>
  );
}
